import React from "react";
import { Link } from "react-router-dom";
import { Search, PenTool, Code2, Rocket, ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function HowItWorks() {
  const { t, lang } = useI18n();
  const steps = [
    [Search, { de: "1. Beratung & Analyse", en: "1. Discovery & Analysis" }, { de: "Wir hören zu, verstehen Ihre Ziele und definieren den Projektumfang gemeinsam.", en: "We listen, understand your goals and define the project scope together." }],
    [PenTool, { de: "2. Konzept & Design", en: "2. Concept & Design" }, { de: "Wireframes, UX/UI-Design und Prototypen — bis alles perfekt sitzt.", en: "Wireframes, UX/UI design and prototypes — until everything fits perfectly." }],
    [Code2, { de: "3. Entwicklung", en: "3. Development" }, { de: "Sauberer, skalierbarer Code mit regelmäßigen Updates und Tests.", en: "Clean, scalable code with regular updates and testing." }],
    [Rocket, { de: "4. Launch & Support", en: "4. Launch & Support" }, { de: "Go-live, Schulung und laufende Betreuung Ihrer Lösung.", en: "Go-live, training and ongoing support for your solution." }],
  ];
  return (
    <div>
      <Seo title={t("home.processTitle")} description={t("home.processSub")} />
      <PageHero eyebrow={t("nav.process")} title={t("home.processTitle")} subtitle={t("home.processSub")} />
      <section className="container-x py-16">
        <div className="grid md:grid-cols-2 gap-6">
          {steps.map(([Icon, title, desc], i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div className="surface p-8 h-full flex gap-5">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary"><Icon size={26} /></div>
                <div>
                  <h3 className="font-display font-bold text-xl mb-2">{title[lang]}</h3>
                  <p className="text-muted-foreground leading-relaxed">{desc[lang]}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Link to="/quote" className="btn-primary" data-testid="hiw-quote">{t("hero.cta1")} <ArrowRight size={16} /></Link>
        </div>
      </section>
    </div>
  );
}
